import React from 'react'
import { Popover } from '@mui/material'
import { DateRangePicker, RangeFocus, RangeKeyDict } from 'react-date-range'
import { blue } from '@mui/material/colors'

import type { Range } from './Helper'

type CustomDateRangePopoverProps = {
  open: boolean
  anchorEl: HTMLElement | null
  onClose: () => void
  selectedDateRange: Range
  onDateRangeChange: (range: RangeKeyDict) => void
  focusedRange: RangeFocus
  onDateRangeFocusChange: (focusRange: RangeFocus) => void
}

const CustomDateRangePopover: React.FC<CustomDateRangePopoverProps> = ({
  open,
  anchorEl,
  onClose,
  selectedDateRange,
  onDateRangeChange,
  focusedRange,
  onDateRangeFocusChange,
}) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
  >
    <DateRangePicker
      months={2}
      color={blue[700]}
      maxDate={new Date()}
      showDateDisplay={false}
      rangeColors={[blue[700]]}
      editableDateInputs={false}
      onChange={onDateRangeChange}
      focusedRange={focusedRange}
      onRangeFocusChange={onDateRangeFocusChange}
      ranges={[{ ...selectedDateRange, key: 'selection' }]}
      direction={window.innerWidth <= 768 ? 'vertical' : 'horizontal'}
    />
  </Popover>
)

export default CustomDateRangePopover
